import CustomButton from "@/components/CustomButton";
import { IS_PRODUCTION } from "@/constants/constants";
import { getHouseholdPrintFileName } from "@/helper/helper";
import { useAppSelector } from "@/hooks/useAppSelector";
import { useNPVPrint } from "@/hooks/useNPVPrint";
import { AxiosError } from "axios";
import { useRef } from "react";
import { toast } from "react-toastify";

type Props = {
  showHiddenRows: boolean;
};

export default function PrintNPVButton({ showHiddenRows }: Props) {
  const { isModified } = useAppSelector((state) => state.npv);
  const {
    household,
    header: { isError },
  } = useAppSelector((state) => state.household);

  const divRef = useRef<HTMLDivElement>(null);
  const { mutateAsync: downloadAsync, error: printErrorMsg } = useNPVPrint();

  const fileName = getHouseholdPrintFileName({
    clientCode: household?.clientCode,
    tabName: "Net Present Value",
  });

  const toastMessages = {
    pending: "Downloading NPV...",
    success: "NPV downloaded!",
    error: printErrorMsg instanceof AxiosError ? printErrorMsg.message : "Downloading NPV failed",
  };

  if (IS_PRODUCTION || isError) return null;

  return (
    <div className="relative" ref={divRef}>
      <CustomButton
        className="print:hidden"
        disabled={isModified}
        text={"Print to PDF"}
        onClickHandler={() => {
          toast.promise(
            downloadAsync({
              externalCode: household?.externalCode,
              clientCode: household?.clientCode,
              fileName,
              showHiddenRows,
            }),
            toastMessages
          );
        }}
      />
    </div>
  );
}
